import React, { useState, useEffect, useRef } from "react";
import { 
  FaGem, 
  FaCrown, 
  FaHandsHelping, 
  FaShieldVirus,
  FaStar,
  FaTrophy,
  FaChartLine,
  FaClock
} from "react-icons/fa";
import "../styles/AchievementsStrip.css";

const AchievementsStrip = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const achievements = [
    { 
      icon: <FaCrown />, 
      value: "Top Rated", 
      label: "Detective Agency",
      color: "#f59e0b",
      bgColor: "rgba(245, 158, 11, 0.1)",
      delay: 0.1
    },
    { 
      icon: <FaGem />, 
      value: "ISO Certified", 
      label: "Quality Standards",
      color: "#3b82f6",
      bgColor: "rgba(59, 130, 246, 0.1)",
      delay: 0.2
    },
    { 
      icon: <FaHandsHelping />, 
      value: "100%", 
      label: "Client Satisfaction",
      color: "#06d881",
      bgColor: "rgba(6, 216, 129, 0.1)",
      delay: 0.3
    },
    { 
      icon: <FaShieldVirus />, 
      value: "24/7", 
      label: "Emergency Service",
      color: "#ef4444",
      bgColor: "rgba(239, 68, 68, 0.1)",
      delay: 0.4
    },
  ];

  return (
    <div className="achievements-premium" ref={sectionRef}>
      <div className="achievements-premium-container">
        {/* Background Pattern */}
        <div className="achievements-bg-pattern"></div>
        
        {/* Section Title (Optional) */}
        <div className="achievements-title">
          <span className="title-icon">🏆</span>
          <span>Our Achievements & Recognition</span>
        </div>

        {/* Achievements Grid */}
        <div className="achievements-premium-grid">
          {achievements.map((item, index) => (
            <div 
              key={index} 
              className={`achievement-premium-card ${isVisible ? "visible" : ""}`}
              style={{ animationDelay: `${item.delay}s` }}
            >
              <div className="card-glow" style={{ background: `radial-gradient(circle, ${item.color}20 0%, transparent 70%)` }}></div>
              <div className="achievement-icon-wrapper" style={{ backgroundColor: item.bgColor }}>
                <div className="achievement-premium-icon" style={{ color: item.color }}>
                  {item.icon}
                </div>
              </div>
              <div className="achievement-premium-content">
                <h4 style={{ color: item.color }}>{item.value}</h4>
                <p>{item.label}</p>
              </div>
              <div className="card-shine"></div>
            </div>
          ))}
        </div>

        {/* Stats Bar */}
        <div className="achievements-stats-bar">
          <div className="stats-item">
            <FaTrophy className="stats-icon" />
            <div>
              <span className="stats-number">5000+</span>
              <span className="stats-label">Cases Solved</span>
            </div>
          </div>
          <div className="stats-divider"></div>
          <div className="stats-item">
            <FaStar className="stats-icon" />
            <div>
              <span className="stats-number">4.9/5</span>
              <span className="stats-label">Client Rating</span>
            </div>
          </div>
          <div className="stats-divider"></div>
          <div className="stats-item">
            <FaChartLine className="stats-icon" />
            <div>
              <span className="stats-number">98%</span>
              <span className="stats-label">Success Rate</span>
            </div>
          </div>
          <div className="stats-divider"></div>
          <div className="stats-item">
            <FaClock className="stats-icon" />
            <div>
              <span className="stats-number">15+</span>
              <span className="stats-label">Years Experience</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchievementsStrip;